<template>
  <details-grid
    loading-sidebar
    :hide-sidebar="isMobile"
    wide
  >
    <div class="tm-details-grid-loading__white-block">
      <div
        v-for="(i, index) in 3"
        :key="i"
        class="d-flex"
        :class="{
          'mt-6': index,
          [`opacity-${8 - index * 2}`]: index,
        }"
      >
        <tm-skeleton
          type="circle"
          width="32px"
          height="32px"
          class="mr-6 gt-sm"
        />

        <div class="mt-2 overflow-hidden">
          <tm-skeleton
            type="QChip"
            width="340px"
            height="16px"
            class="mb-2"
          />
          <tm-skeleton
            type="QChip"
            width="200px"
            height="8px"
          />
        </div>
      </div>
    </div>
    <template v-slot:sidebar>
      <tm-skeleton
        width="128px"
        height="16px"
        class="mb-7"
        type="QChip"
      />

      <div
        v-for="(i, index) in 5"
        :key="i"
        :class="{
          'mt-8': index,
        }"
      >
        <tm-skeleton
          width="80px"
          height="10px"
          type="QChip"
        />
        <tm-skeleton
          width="168px"
          height="16px"
          class="mt-6px"
          type="QChip"
        />
      </div>
    </template>
  </details-grid>
</template>

<script lang="ts">
// layout name TmDetailsGridLoading.vue
import { defineComponent, computed } from '@/composition/vue/compositionApi'
import DetailsGrid from '@/components/shared/templates/details/DetailsGrid.vue'
import TmSkeleton from '@/components/shared/skeletons/TmSkeleton.vue'
import { useBreakpoints } from '@/composition/breakpoints'

export default defineComponent({
  components: {
    TmSkeleton,
    DetailsGrid,
  },
  setup() {
    const { isLaptop, isMobile } = useBreakpoints()

    const btnCount = computed(() => (isLaptop.value ? 2 : 3))
    const topBtnCount = computed(() => (isMobile.value ? 4 : 5))

    return {
      btnCount,
      topBtnCount,
      isMobile,
    }
  },
})
</script>

<style lang="scss" scoped>
.opacity-6 {
  opacity: 0.6;
}

.opacity-4 {
  opacity: 0.4;
}

.mt-6px {
  margin-top: 6px;
}

.tm-details-grid-loading__white-block {
  background: linear-gradient(180deg, $white 50%, rgba(255, 255, 255, 0) 100%);
  border-radius: $border-radius-md;
  padding: 28px 24px;
  min-height: 330px;

  @include media-sm-x-max {
    padding: 16px 16px 24px;
  }
}
</style>
